module.exports = __webpack_public_path__ + "static/img/transparent-check.437e1747.svg";